<script>
/**
 * Blog component
 */
export default {
  name: 'Blog'
}
</script>

<template>
  <!-- START BLOG -->
  <section class="section bg-light main-section" id="blog"
  
  :style="{'background-image': 'url(' + require('@/assets/images/home-image.png') + ')', 'background-size': 'cover','background-position': 'center'}"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">The process</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >Become the next success story</p>
        </div>
      </div>

      <div class="row margin-t-30 cards-container" style="justify-content: center;">
        <div class="col-lg-4">
          <div class="blog-box margin-t-30">
            <a href="#contact-form">
            <img src="@/assets/images/step1.png" class="img-fluid rounded" alt />
          </a>
            <div>
              <h5 class="mt-4 text-muted">First Step</h5>
              <h4 class="mt-3">
                <a href="#contact-form" class="blog-title">Reach out</a>
              </h4>
              <p
                class="text-muted"
              >Reach out to our team of consulting managers</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30">
            <a href="#contact-form">
            <img src="@/assets/images/meeting.png" class="img-fluid rounded" alt />
            </a>
            <div>
              <h5 class="mt-4 text-muted">Second Step</h5>
              <h4 class="mt-3">
                <a href="#contact-form" class="blog-title">Schedule an appointment</a>
              </h4>
              <p
                class="text-muted"
              >Get consulting about expanding your business</p>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="blog-box margin-t-30">
            <a href="#contact-form">
            <img src="@/assets/images/step3.png" class="img-fluid rounded" alt />
            </a>
            <div>
              <h5 class="mt-4 text-muted">Third Step</h5>
              <h4 class="mt-3">
                <a href="#contact-form" class="blog-title">We do the work</a>
              </h4>
              <p
                class="text-muted"
              >Our team of professional developers and business architects will have your business's expansion as a main task. Delivering results and helping you grow will be our main priority.</p>
            </div>
          </div>
        </div>




      </div>
    </div>
  </section>
  <!-- END BLOG -->
</template>
<style scoped>

*, a, p, h4
{
color: white !important;
}
.img-fluid
{
  transition: 0.3s;
}
.img-fluid:hover
{
  cursor: pointer;
  scale: 1.08;
}
@media only screen and (max-width: 990px) {
  .cards-container
  {
    display: flex;
    justify-content: center;
  }
  .container
  {
    display: flex;
    flex-direction: column;
  }
  .col-lg-4
  {
    display: flex;
    justify-content: center;
    max-width: 50%;
    min-width: 300px;
  }
  .blog-box
  {
    max-width: 100%;
  }
}
</style>